import script from "./Legal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Legal.vue?vue&type=script&setup=true&lang=ts"

import "./Legal.vue?vue&type=style&index=0&id=2ddaa02e&lang=css"

const __exports__ = script;

export default __exports__